import React, { useEffect, useMemo, useState } from 'react'
import cn from 'classnames'
import { observer, useStore } from '@/hooks/storeHooks'
import { nanoid } from 'nanoid'
import st from './index.scss'
import { makeAutoObservable } from 'mobx'
import toast from 'react-hot-toast'
import { useRequest } from 'ahooks'
class reportStore {
    constructor() {
        makeAutoObservable(this)
    }
    reportList = []
    selectReport = null
    selectReportObj = null
    changeSelectReport = (e) => {
        this.selectReport = e
    }
    changeReportList = (e) => {
        this.reportList = e
    }
    changeSelectReportObj = (e) => {
        this.selectReportObj = e
    }
}

/**
 * close 关闭方法
 * answerId 答题ID
 * questionId 父级ID
 * userId 用户ID
 * reportFun 举报方法
 */
export default observer(function Report({
    close,
    answerId = null,
    questionId = null,
    userId = null,
    reportFun // 举报方法
}) {
    const [store] = useState(() => new reportStore())
    const { api, user } = useStore()
    let { data, error, ling } = useRequest(() =>
        user
            .post(api.oneDay_get_report_class, {
                type: 1
            })
            .then((res) => {
                store.changeReportList(res.data)
            })
    )
    function submit() {
        if (!store.selectReport) return toast.error('请选择举报类型')
        if (!answerId) return toast.error('答案id不能为空')
        if (!questionId) return toast.error('题目id不能为空')

        // 举报方法
        if (reportFun) {
            return reportFun({
                selectReportObj: store.selectReportObj
            })
        }

        user.post(api.oneDay_report, {
            answerId: answerId,
            questionId: questionId,
            userId: userId,
            reportContent: store.selectReport
        }).then((data) => {
            toast.success('举报成功')
            close()
        })
    }
    return (
        <div className={st['box']}>
            <div className={st['reportMain']}>
                <h3 className={st['header']}>
                    我要举报
                    <span
                        onClick={() => {
                            close()
                        }}
                    >
                        ×
                    </span>
                </h3>
                <div className={st['main']}>
                    <h4>举报类型</h4>
                    <div className={st['selectBox']}>
                        {store?.reportList.map((e) => {
                            return (
                                <p
                                    key={nanoid()}
                                    onClick={() => {
                                        store.changeSelectReport(e.label)
                                        store.changeSelectReportObj(e)

                                    }}
                                    className={cn({
                                        [st['select']]:
                                            store.selectReport == e.label
                                    })}
                                >
                                    {e.label}
                                </p>
                            )
                        })}
                    </div>
                </div>
                <div onClick={submit} className={st['submit']}>
                    确认
                </div>
            </div>
        </div>
    )
})
